// extracted by mini-css-extract-plugin
export default {"time":"Countdown-module__time","timeWarning":"Countdown-module__timeWarning"};